export const DEFAULT_APPLICATION_TITLE = "Authentication System";
